// extracted by mini-css-extract-plugin
export default {"select":"NumberingPattern_select__mtrP3"};